export const prodConfig = {
  API_BASE_URL: "",
  FRONTEND_URL: "",
};
